__turbopack_context__.v({
  "fade": "StarRating-module-scss-module__yjtfpW__fade",
  "fade-slide": "StarRating-module-scss-module__yjtfpW__fade-slide",
  "open-from-center": "StarRating-module-scss-module__yjtfpW__open-from-center",
  "planStarRating": "StarRating-module-scss-module__yjtfpW__planStarRating",
  "planStarsContainer": "StarRating-module-scss-module__yjtfpW__planStarsContainer",
  "spin": "StarRating-module-scss-module__yjtfpW__spin",
  "title": "StarRating-module-scss-module__yjtfpW__title",
});
